module.exports = __webpack_public_path__ + "img/project-details-cover.4a03a32f.png";